"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAlignableWidget = exports.isResizeableWidget = exports.isContainerManagedWidget = exports.getGenericConfigByType = exports.getConfigByType = exports.createContentLoopNode = exports.createContentLoopBodyNode = exports.createSideBySideColumnNode = exports.configs = exports.createAccordionBody = exports.createAccordionHeading = exports.createButtonNode = exports.createVideoNode = exports.createBlockQuoteNode = exports.createParagraphNode = exports.createHeading2Node = exports.createHeading1Node = exports.createHorizontalRuleNode = void 0;
var Deserialise_1 = require("Project/QwilrEditor/Tokenization/Deserialise");
var Serialise_1 = require("../Tokenization/Serialise");
var NormalizeVoidNode_1 = require("../Schemas/NormalizeVoidNode");
var slate_1 = require("slate");
var react_1 = __importDefault(require("react"));
var CommonWidgetRegistry_1 = require("@CommonFrontend/WidgetRegistry/CommonWidgetRegistry");
var ChevronWidget_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/Chevron/ChevronWidget");
var Models_1 = require("@CommonFrontend/ContentTokens/Models");
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
var WidgetActions_1 = require("../Behaviours/WidgetActions");
var Text_1 = require("@CommonFrontend/ContentTokens/DataModels/Text");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var TelemetryParameterValue_1 = require("@CommonFrontend/Telemetry/TelemetryParameterValue");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var WidgetManager_1 = require("../WidgetManager");
var inversify_react_1 = require("inversify-react");
var slate_2 = require("slate");
var TokenModels_1 = __importDefault(require("@CommonFrontend/ContentTokens/TokenModels"));
var Utils_1 = require("../Utils");
var BoxWidget_1 = require("../Widgets/BoxWidget/BoxWidget");
var BoxColumn_1 = require("../Widgets/BoxWidget/BoxColumn");
var QuoteSummary_1 = __importStar(require("../Widgets/QuoteSummary"));
var HorizontalRuleWidget_1 = require("../Widgets/HorizontalRuleWidget/HorizontalRuleWidget");
var VideoWidget_1 = require("../Widgets/VideoWidget/VideoWidget");
var Video_1 = require("@CommonFrontend/ContentTokens/DataModels/Video");
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var ButtonWidget_1 = require("../Widgets/ButtonWidget");
var lodash_1 = require("lodash");
var EmbedRegistryWidget_1 = require("../Widgets/EmbedRegistryWidget");
var EditorPlaceholder_1 = __importDefault(require("../Placeholder/EditorPlaceholder"));
var QuoteSummaryWidget_1 = require("@CommonFrontend/ContentTokens/SharedWidgetComponents/QuoteSummary/QuoteSummaryWidget");
var ROICalculatorWidget_1 = require("../Widgets/ROICalculatorWidget/ROICalculatorWidget");
var GoogleMapsRegistryWidget_1 = require("../Widgets/GoogleMapsWidget/GoogleMapsRegistryWidget");
var GoogleMapsToolbarButtons_1 = require("../Widgets/GoogleMapsWidget/GoogleMapsToolbarButtons");
var ListItem_1 = require("../Widgets/ListItem/ListItem");
var EditorTypes_1 = require("../EditorTypes");
var ImageWidget_1 = require("../Widgets/ImageWidget/ImageWidget");
var Types_1 = require("@CommonFrontend/ContentTokens/Models/inputs/Types");
var ImageWidgetToolbarButtons_1 = require("../Widgets/ImageWidget/ImageWidgetToolbarButtons");
var ImageWidgetContext_1 = require("../Widgets/ImageWidget/ImageWidgetContext");
var OnAddWidget_1 = require("../Widgets/ImageWidget/OnAddWidget");
var slate_react_1 = require("slate-react");
var BlockStyleTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/BlockStyleTypes");
var AccordionRegistryWidget_1 = require("../Widgets/AccordionWidget/AccordionRegistryWidget");
var AccordionBody_1 = require("../Widgets/AccordionWidget/AccordionBody");
var AccordionHeading_1 = require("../Widgets/AccordionWidget/AccordionHeading");
var AccordionWidgetToolbarButtons_1 = require("../Widgets/AccordionWidget/AccordionWidgetToolbarButtons");
var AccordionRegistryContext_1 = require("../Widgets/AccordionWidget/AccordionRegistryContext");
var DeserialiseErrorRecorder_1 = require("../Tokenization/DeserialiseErrorRecorder");
var SideBySide_1 = require("@CommonFrontend/ContentTokens/Models/SideBySide");
var SideBySideWidget_1 = __importDefault(require("../Widgets/SideBySideWidget/SideBySideWidget"));
var SideBySideColumn_1 = require("../Widgets/SideBySideWidget/SideBySideColumn");
var ContentLoopRegistryWidget_1 = require("../Widgets/ContentLoopWidget/ContentLoopRegistryWidget");
var ContentLoopBodyRegistry_1 = require("../Widgets/ContentLoopWidget/ContentLoopBodyRegistry");
var ContentLoopToolbarButtons_1 = require("../Widgets/ContentLoopWidget/ContentLoopToolbarButtons");
var ContentLoopWidgetContext_1 = require("../Widgets/ContentLoopWidget/ContentLoopWidgetContext");
var makeConfig = function (config) { return config; };
var makeContainerManagedConfig = function (config) { return config; };
var chevronConfig = makeConfig(__assign(__assign({}, (0, CommonWidgetRegistry_1.getConfigByType)("chevron")), { editorRender: ChevronWidget_1.ChevronWidget, node: {}, nodeType: "void", toolbarButtons: function ChevronToolbarButtons(_a) {
        var element = _a.element;
        var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
        return (react_1.default.createElement(kaleidoscope_1.Popover, { theme: kaleidoscope_1.PopoverTheme.Dark, size: kaleidoscope_1.PopoverSize.Small, button: function (buttonProps) { return react_1.default.createElement(kaleidoscope_1.ToolbarButton, __assign({}, buttonProps, { icon: react_1.default.createElement(icons_1.Edit, null) })); }, autoStack: true },
            react_1.default.createElement(kaleidoscope_1.Toggle, { label: "Click to scroll", theme: kaleidoscope_1.ToggleTheme.Dark, value: element.data.clickToScroll, onChange: function (isActive) {
                    widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("any", {
                        action: "update",
                        path: widgetManager.getPath(element),
                        type: element.type,
                        data: {
                            clickToScroll: isActive,
                        },
                    }));
                } })));
    }, serialise: function (node, editor, commentTracker, selection) { return __spreadArray([
        { subType: "chevron", type: "block", clickToScroll: node.data.clickToScroll }
    ], __read((0, Serialise_1.getChildTokens)(node, editor, commentTracker, selection)), false); }, deserialise: function (token) {
        var _a;
        return ({
            type: "chevron",
            data: {
                clickToScroll: (_a = token.clickToScroll) !== null && _a !== void 0 ? _a : true,
            },
            children: [Text_1.text.createSlateJson()],
            isVoid: true,
        });
    }, normalizeWidget: function (node, path, editor) { return (0, NormalizeVoidNode_1.normalizeVoidNode)(node, path, editor); }, firstLastConfiguration: {
        isValidFirstChild: true,
    }, validEditors: ["standard"], validContainers: ["accordionBody", "contentLoopBody", "sideBySideColumn", "boxColumn"], widgetAdderConfig: {
        tags: ["chevron", "scroll"],
        icon: react_1.default.createElement(icons_1.ChevronDown, null),
        requiresFeatures: [FeatureFlag_1.FeatureFlag.EditorRegistryWidgets],
    }, onAddWidget: function (_a) {
        var editor = _a.editor;
        (0, WidgetActions_1.addWidget)({
            editor: editor,
            widgetData: createChevronNode(),
        });
    }, contentAddedType: TelemetryParameterValue_1.ContentAddedType.Chevron, width: "fit-widget" }));
var createChevronNode = function () { return ({
    type: "chevron",
    data: { clickToScroll: true },
    children: [Text_1.text.createSlateJson()],
    isVoid: true,
}); };
var createQuoteSummaryNode = function () { return ({
    type: "quoteSummary",
    children: [Text_1.text.createSlateJson()],
    isVoid: true,
    data: __assign({}, QuoteSummaryWidget_1.quoteSummaryWidgetDefaultSettings),
}); };
var boxConfig = makeConfig(__assign(__assign({}, (0, CommonWidgetRegistry_1.getConfigByType)("box")), { node: {}, nodeType: "layoutElement", editorRender: BoxWidget_1.BoxWidget, firstLastConfiguration: { isValidFirstChild: true }, width: "full-width", deserialise: function (token, content, commentTracker) {
        return {
            type: "box",
            children: token.columns.map(function (children) { return ({
                children: (0, Deserialise_1.deserialiseNode)(children, commentTracker).children,
                type: "boxColumn",
                isVoid: false,
            }); }),
            isVoid: false,
            data: {},
        };
    }, serialise: function (node, editor, commentTracker, selection) {
        var children = node.children;
        return [
            {
                type: "block",
                subType: "box",
                columns: [
                    (0, Serialise_1.serialiseElements)(children[0].children, editor, commentTracker, selection),
                    (0, Serialise_1.serialiseElements)(children[1].children, editor, commentTracker, selection),
                ],
            },
        ];
    }, onAddWidget: function (_a) {
        var editor = _a.editor;
        var widget = createEmptyBox();
        var currentSelection = editor.selection;
        if (!slate_1.Range.isRange(currentSelection)) {
            return;
        }
        var currBlockEntry = (0, Utils_1.getClosestBlock)(editor, slate_1.Range.start(currentSelection).path);
        if (!currBlockEntry) {
            return;
        }
        slate_1.Editor.withoutNormalizing(editor, function () {
            slate_1.Transforms.removeNodes(editor, { at: currBlockEntry[1] });
            slate_1.Transforms.insertNodes(editor, widget, { at: currBlockEntry[1] });
        });
    }, validContainers: ["sideBySideColumn", "accordionBody", "contentLoopBody", "boxColumn"], validEditors: ["standard"], normalizeWidget: function (node, path, editor) {
        for (var i = 0; i < node.children.length; i++) {
            var currChild = node.children[i];
            if (slate_1.Text.isText(currChild) || currChild.type !== "boxColumn") {
                slate_1.Transforms.delete(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false) });
                return true;
            }
        }
        if (node.children.length < 2) {
            slate_1.Transforms.insertNodes(editor, createEmptyBoxColumn(), { at: __spreadArray(__spreadArray([], __read(path), false), [0], false) });
            return true;
        }
        return false;
    }, widgetAdderConfig: {
        icon: react_1.default.createElement(icons_1.LinkedinBox, null),
        tags: ["box", "2col", "layout"],
        displayName: "box",
        requiresFeatures: [FeatureFlag_1.FeatureFlag.EditorRegistryWidgets],
    }, contentAddedType: TelemetryParameterValue_1.ContentAddedType.Box, containerNodeConfiguration: {
        showWidgetAdder: false,
    } }));
var horizontalRuleConfig = makeConfig(__assign(__assign({}, (0, CommonWidgetRegistry_1.getConfigByType)("horizontalRule")), { editorRender: HorizontalRuleWidget_1.HorizontalRuleWidget, node: {}, nodeType: "void", serialise: function (node, editor, commentTracker, selection) { return __spreadArray([
        { subType: "horizontalRule", type: "block" }
    ], __read((0, Serialise_1.getChildTokens)(node, editor, commentTracker, selection)), false); }, deserialise: function () { return ({
        type: "horizontalRule",
        children: [Text_1.text.createSlateJson()],
        isVoid: true,
    }); }, normalizeWidget: function (node, path, editor) { return (0, NormalizeVoidNode_1.normalizeVoidNode)(node, path, editor); }, firstLastConfiguration: {
        isValidFirstChild: true,
    }, validEditors: ["standard", "agreement"], validContainers: ["accordionBody", "contentLoopBody", "sideBySideColumn", "boxColumn"], widgetAdderConfig: {
        tags: ["horizontal rule", "hr", "line", "divider"],
        icon: react_1.default.createElement(icons_1.WidgetDivider, null),
        displayName: "Divider",
    }, onAddWidget: function (_a) {
        var editor = _a.editor;
        (0, WidgetActions_1.addWidget)({
            editor: editor,
            widgetData: (0, exports.createHorizontalRuleNode)(),
        });
    }, contentAddedType: TelemetryParameterValue_1.ContentAddedType.HorizontalRule, width: "full-width" }));
var createHorizontalRuleNode = function () { return ({
    type: "horizontalRule",
    children: [Text_1.text.createSlateJson()],
    isVoid: true,
}); };
exports.createHorizontalRuleNode = createHorizontalRuleNode;
var heading1Config = makeConfig(__assign(__assign({}, (0, CommonWidgetRegistry_1.getConfigByType)("heading1")), { editorRender: function (_a) {
        var element = _a.element, attributes = _a.attributes, children = _a.children;
        return react_1.default.createElement("h1", attributes, react_1.default.createElement(EditorPlaceholder_1.default, { element: element }), children);
    }, node: {}, nodeType: "textElement", serialise: function (node, editor, commentTracker, selection) { return __spreadArray([
        { subType: "heading1", type: "block" }
    ], __read((0, Serialise_1.getChildTokens)(node, editor, commentTracker, selection)), false); }, deserialise: function () { return ({
        type: "heading1",
        data: {},
        children: [],
        isVoid: false,
    }); }, normalizeWidget: function (node, path, editor) {
        var _a;
        var config = (0, exports.getConfigByType)(node.type);
        for (var i = 0; i < node.children.length; i++) {
            var currChild = node.children[i];
            if (slate_1.Text.isText(currChild)) {
                continue;
            }
            var childConfig = getGenericConfigByType(currChild.type);
            if (childConfig
                ? !childConfig.validContainers.includes(node.type)
                : ((_a = config.textNodeConfiguration) === null || _a === void 0 ? void 0 : _a.validChildren) &&
                    !config.textNodeConfiguration.validChildren.includes(currChild.type)) {
                slate_1.Transforms.unwrapNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false), voids: true });
                return true;
            }
        }
        if (node.children.length === 0) {
            slate_1.Transforms.insertNodes(editor, TokenModels_1.default.text.createSlateJson(""), { at: __spreadArray(__spreadArray([], __read(path), false), [0], false) });
            return true;
        }
        return false;
    }, width: "full-width", validEditors: ["standard", "agreement"], validContainers: [
        "accordionHeading",
        "accordionBody",
        "contentLoopBody",
        "sideBySideColumn",
        Models_1.BlockType.TableCell,
        "boxColumn",
    ], firstLastConfiguration: {
        isValidFirstChild: true,
    }, onAddWidget: function (_a) {
        var editor = _a.editor;
        (0, WidgetActions_1.addWidget)({
            editor: editor,
            widgetData: (0, exports.createHeading1Node)(),
        });
    }, textNodeConfiguration: {
        validChildren: [Models_1.InlineType.Link, Models_1.InlineType.LineBreak, Models_1.InlineType.Variable, Models_1.InlineType.TokenWidget],
    } }));
var heading2Config = makeConfig(__assign(__assign({}, (0, CommonWidgetRegistry_1.getConfigByType)("heading2")), { editorRender: function (_a) {
        var element = _a.element, attributes = _a.attributes, children = _a.children;
        return react_1.default.createElement("h2", attributes, react_1.default.createElement(EditorPlaceholder_1.default, { element: element }), children);
    }, node: {}, nodeType: "textElement", serialise: function (node, editor, commentTracker, selection) { return __spreadArray([
        { subType: "heading2", type: "block" }
    ], __read((0, Serialise_1.getChildTokens)(node, editor, commentTracker, selection)), false); }, deserialise: function () { return ({
        type: "heading2",
        data: {},
        children: [],
        isVoid: false,
    }); }, normalizeWidget: function (node, path, editor) {
        var _a;
        var config = (0, exports.getConfigByType)(node.type);
        for (var i = 0; i < node.children.length; i++) {
            var currChild = node.children[i];
            if (slate_1.Text.isText(currChild)) {
                continue;
            }
            var childConfig = getGenericConfigByType(currChild.type);
            if (childConfig
                ? !childConfig.validContainers.includes(node.type)
                : ((_a = config.textNodeConfiguration) === null || _a === void 0 ? void 0 : _a.validChildren) &&
                    !config.textNodeConfiguration.validChildren.includes(currChild.type)) {
                slate_1.Transforms.unwrapNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false), voids: true });
                return true;
            }
        }
        if (node.children.length === 0) {
            slate_1.Transforms.insertNodes(editor, TokenModels_1.default.text.createSlateJson(""), { at: __spreadArray(__spreadArray([], __read(path), false), [0], false) });
            return true;
        }
        return false;
    }, width: "full-width", validEditors: ["standard", "agreement", "quotePlanCard", "quote"], validContainers: [
        "accordionHeading",
        "accordionBody",
        "contentLoopBody",
        "sideBySideColumn",
        Models_1.BlockType.TableCell,
        "boxColumn",
    ], firstLastConfiguration: {
        isValidFirstChild: true,
    }, onAddWidget: function (_a) {
        var editor = _a.editor;
        (0, WidgetActions_1.addWidget)({
            editor: editor,
            widgetData: (0, exports.createHeading2Node)(),
        });
    }, textNodeConfiguration: {
        validChildren: [Models_1.InlineType.Link, Models_1.InlineType.LineBreak, Models_1.InlineType.Variable, Models_1.InlineType.TokenWidget],
    } }));
var paragraphConfig = makeConfig(__assign(__assign({}, (0, CommonWidgetRegistry_1.getConfigByType)("paragraph")), { editorRender: function (_a) {
        var element = _a.element, attributes = _a.attributes, children = _a.children;
        return react_1.default.createElement("p", attributes, react_1.default.createElement(EditorPlaceholder_1.default, { element: element }), children);
    }, node: {}, nodeType: "textElement", serialise: function (node, editor, commentTracker, selection) { return __spreadArray([
        { subType: "paragraph", type: "block" }
    ], __read((0, Serialise_1.getChildTokens)(node, editor, commentTracker, selection)), false); }, deserialise: function () { return ({
        type: "paragraph",
        data: {},
        children: [],
        isVoid: false,
    }); }, normalizeWidget: function (node, path, editor) {
        var _a;
        var config = (0, exports.getConfigByType)(node.type);
        for (var i = 0; i < node.children.length; i++) {
            var currChild = node.children[i];
            if (slate_1.Text.isText(currChild)) {
                continue;
            }
            var childConfig = getGenericConfigByType(currChild.type);
            if (childConfig
                ? !childConfig.validContainers.includes(node.type)
                : ((_a = config.textNodeConfiguration) === null || _a === void 0 ? void 0 : _a.validChildren) &&
                    !config.textNodeConfiguration.validChildren.includes(currChild.type)) {
                slate_1.Transforms.unwrapNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false), voids: true });
                return true;
            }
        }
        if (node.children.length === 0) {
            slate_1.Transforms.insertNodes(editor, TokenModels_1.default.text.createSlateJson(""), { at: __spreadArray(__spreadArray([], __read(path), false), [0], false) });
            return true;
        }
        return false;
    }, width: "full-width", validEditors: ["standard", "agreement", "quotePlanCard", "quote", "quoteLineItem", "quotePlanCardFeatureList"], validContainers: [
        "accordionHeading",
        "accordionBody",
        "contentLoopBody",
        "sideBySideColumn",
        Models_1.BlockType.TableCell,
        "boxColumn",
    ], firstLastConfiguration: {
        isValidFirstChild: true,
    }, onAddWidget: function (_a) {
        var editor = _a.editor;
        (0, WidgetActions_1.addWidget)({
            editor: editor,
            widgetData: (0, exports.createHeading2Node)(),
        });
    }, textNodeConfiguration: {
        validChildren: [Models_1.InlineType.Link, Models_1.InlineType.LineBreak, Models_1.InlineType.Variable, Models_1.InlineType.TokenWidget],
    } }));
var listItemConfig = makeConfig(__assign(__assign({}, (0, CommonWidgetRegistry_1.getConfigByType)("listItem")), { editorRender: ListItem_1.ListItem, node: {}, nodeType: "textElement", serialise: function (node, editor, commentTracker, selection) { return __spreadArray([
        __assign({ subType: "listItem", type: "block", level: node.data.level, listType: node.data.listType }, (0, CommonUtils_1.includeIf)(node.data.startCounter != undefined, { startCounter: node.data.startCounter }))
    ], __read((0, Serialise_1.getChildTokens)(node, editor, commentTracker, selection)), false); }, deserialise: function (token) { return ({
        type: "listItem",
        data: __assign({ level: token.level, listType: token.listType }, (0, CommonUtils_1.includeIf)(token.startCounter != undefined, { startCounter: token.startCounter })),
        children: [],
        isVoid: false,
    }); }, normalizeWidget: function (node, path, editor) {
        for (var i = 0; i < node.children.length; i++) {
            var currChild = node.children[i];
            if (slate_1.Text.isText(currChild)) {
                continue;
            }
            if (![Models_1.InlineType.Link, Models_1.InlineType.LineBreak, Models_1.InlineType.Variable, Models_1.InlineType.TokenWidget].includes(currChild.type)) {
                slate_1.Transforms.unwrapNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false), voids: true });
                return true;
            }
        }
        if (node.children.length === 0) {
            slate_1.Transforms.insertNodes(editor, TokenModels_1.default.text.createSlateJson(""), { at: __spreadArray(__spreadArray([], __read(path), false), [0], false) });
            return true;
        }
        var data = node.data;
        var level = data.level;
        var listType = data.listType;
        var startCounter = data.startCounter;
        var shouldNormalize = false;
        if (level == undefined || level < 1) {
            shouldNormalize = true;
            level = 1;
        }
        if (listType !== EditorTypes_1.ListType.Bullet && listType !== EditorTypes_1.ListType.Number) {
            shouldNormalize = true;
            listType = EditorTypes_1.ListType.Bullet;
        }
        if (shouldNormalize) {
            var normalizedData = {
                level: level,
                listType: listType,
            };
            if (startCounter != undefined) {
                normalizedData.startCounter = startCounter;
            }
            slate_1.Transforms.setNodes(editor, { data: normalizedData }, { at: path });
            return true;
        }
        return false;
    }, width: "full-width", validEditors: ["standard", "agreement", "quotePlanCardFeatureList", "quote"], validContainers: ["accordionBody", "contentLoopBody", "sideBySideColumn", Models_1.BlockType.TableCell, "boxColumn"], firstLastConfiguration: {
        isValidFirstChild: true,
    }, onAddWidget: function (_a) {
        var editor = _a.editor;
        (0, WidgetActions_1.addWidget)({
            editor: editor,
            widgetData: (0, exports.createHeading2Node)(),
        });
    }, textNodeConfiguration: {
        validChildren: [Models_1.InlineType.Link, Models_1.InlineType.LineBreak, Models_1.InlineType.Variable, Models_1.InlineType.TokenWidget],
    } }));
var blockQuoteConfig = makeConfig(__assign(__assign({}, (0, CommonWidgetRegistry_1.getConfigByType)("blockQuote")), { editorRender: function (_a) {
        var attributes = _a.attributes, children = _a.children;
        return react_1.default.createElement("blockquote", attributes, children);
    }, node: {}, nodeType: "textElement", serialise: function (node, editor, commentTracker, selection) { return __spreadArray([
        { subType: "blockQuote", type: "block" }
    ], __read((0, Serialise_1.getChildTokens)(node, editor, commentTracker, selection)), false); }, deserialise: function () { return ({
        type: "blockQuote",
        children: [],
        isVoid: false,
    }); }, normalizeWidget: function (node, path, editor) {
        var _a;
        var config = (0, exports.getConfigByType)(node.type);
        for (var i = 0; i < node.children.length; i++) {
            var currChild = node.children[i];
            if (slate_1.Text.isText(currChild)) {
                continue;
            }
            var childConfig = getGenericConfigByType(currChild.type);
            if (childConfig
                ? !childConfig.validContainers.includes(node.type)
                : ((_a = config.textNodeConfiguration) === null || _a === void 0 ? void 0 : _a.validChildren) &&
                    !config.textNodeConfiguration.validChildren.includes(currChild.type)) {
                slate_1.Transforms.unwrapNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false), voids: true });
                return true;
            }
        }
        if (node.children.length === 0) {
            slate_1.Transforms.insertNodes(editor, TokenModels_1.default.text.createSlateJson(""), { at: __spreadArray(__spreadArray([], __read(path), false), [0], false) });
            return true;
        }
        return false;
    }, width: "full-width", validEditors: ["standard"], validContainers: ["accordionBody", "contentLoopBody", "sideBySideColumn", "boxColumn"], firstLastConfiguration: {
        isValidFirstChild: true,
    }, onAddWidget: function (_a) {
        var editor = _a.editor;
        (0, WidgetActions_1.addWidget)({
            editor: editor,
            widgetData: (0, exports.createBlockQuoteNode)(),
        });
    }, textNodeConfiguration: {
        validChildren: [Models_1.InlineType.Link, Models_1.InlineType.LineBreak, Models_1.InlineType.Variable, Models_1.InlineType.TokenWidget],
    } }));
var createHeading1Node = function () { return ({
    type: "heading1",
    children: [Text_1.text.createSlateJson()],
    isVoid: false,
}); };
exports.createHeading1Node = createHeading1Node;
var createHeading2Node = function () { return ({
    type: "heading2",
    children: [Text_1.text.createSlateJson()],
    isVoid: false,
}); };
exports.createHeading2Node = createHeading2Node;
var createParagraphNode = function (children) { return ({
    type: "paragraph",
    children: children !== null && children !== void 0 ? children : [Text_1.text.createSlateJson()],
    isVoid: false,
}); };
exports.createParagraphNode = createParagraphNode;
var createBlockQuoteNode = function () { return ({
    type: "blockQuote",
    children: [Text_1.text.createSlateJson()],
    isVoid: false,
}); };
exports.createBlockQuoteNode = createBlockQuoteNode;
var createVideoNode = function () {
    return {
        type: "video",
        children: [Text_1.text.createSlateJson()],
        isVoid: true,
        data: {
            displayUrl: "",
        },
    };
};
exports.createVideoNode = createVideoNode;
var videoWidgetConfig = makeConfig(__assign(__assign({}, (0, CommonWidgetRegistry_1.getConfigByType)("video")), { editorRender: VideoWidget_1.VideoWidget, toolbarButtons: VideoWidget_1.VideoToolbarButtons, node: {}, nodeType: "void", serialise: function (node, editor, commentTracker, selection) {
        var token = __assign(__assign(__assign({ type: "block", subType: "video" }, (0, CommonUtils_1.includeIf)(!!node.data.displayUrl, { displayUrl: node.data.displayUrl })), (0, CommonUtils_1.includeIf)(!!node.data.embedUrl, {
            embedUrl: (0, Video_1.updateEmbedUrlPrefix)(node.data.embedUrl),
        })), (0, CommonUtils_1.includeIf)(!!node.data.variable, {
            variable: node.data.variable,
        }));
        return __spreadArray([token], __read((0, Serialise_1.getChildTokens)(node, editor, commentTracker, selection)), false);
    }, deserialise: function (token) {
        var _a;
        return {
            type: "video",
            children: [Text_1.text.createSlateJson()],
            isVoid: true,
            data: __assign(__assign({ displayUrl: (_a = token.displayUrl) !== null && _a !== void 0 ? _a : "", width: token.width }, (0, CommonUtils_1.includeIf)(!!token.embedUrl, { embedUrl: (0, Video_1.updateEmbedUrlPrefix)(token.embedUrl) })), (0, CommonUtils_1.includeIf)(!!token.variable, {
                variable: token.variable,
            })),
        };
    }, normalizeWidget: function (node, path, editor) { return (0, NormalizeVoidNode_1.normalizeVoidNode)(node, path, editor); }, firstLastConfiguration: {
        isValidFirstChild: true,
    }, validEditors: ["standard"], validContainers: ["accordionBody", "contentLoopBody", "sideBySideColumn", "boxColumn"], widgetAdderConfig: {
        tags: ["youtube", "vimeo", "wistia", "brightcove", "media"],
        icon: react_1.default.createElement(icons_1.WidgetVideo, null),
        displayName: "Video",
    }, onAddWidget: function (_a) {
        var editor = _a.editor;
        var node = (0, exports.createVideoNode)();
        (0, WidgetActions_1.addWidget)({
            editor: editor,
            widgetData: node,
        });
    }, contentAddedType: TelemetryParameterValue_1.ContentAddedType.Video, width: "full-width" }));
var quoteSummaryConfig = makeConfig(__assign(__assign({}, (0, CommonWidgetRegistry_1.getConfigByType)("quoteSummary")), { node: {}, nodeType: "void", editorRender: QuoteSummary_1.default, toolbarButtons: QuoteSummary_1.QuoteSummaryToolbarButtons, serialise: function (node, editor, commentTracker, selection) { return __spreadArray([
        {
            subType: "quoteSummary",
            type: "block",
            showFeatureLists: node.data.showFeatureLists,
            showTextItems: node.data.showTextItems,
            showPlanSectionHeaders: node.data.showPlanSectionHeaders,
            compactLineItemDescriptions: node.data.compactLineItemDescriptions,
            compactSectionHeaders: node.data.compactSectionHeaders,
        }
    ], __read((0, Serialise_1.getChildTokens)(node, editor, commentTracker, selection)), false); }, deserialise: function (token) {
        var _a, _b, _c, _d, _e;
        return ({
            type: "quoteSummary",
            children: [Text_1.text.createSlateJson()],
            isVoid: true,
            data: {
                showFeatureLists: (_a = token.showFeatureLists) !== null && _a !== void 0 ? _a : QuoteSummaryWidget_1.quoteSummaryWidgetDefaultSettings.showFeatureLists,
                showTextItems: (_b = token.showTextItems) !== null && _b !== void 0 ? _b : QuoteSummaryWidget_1.quoteSummaryWidgetDefaultSettings.showTextItems,
                showPlanSectionHeaders: (_c = token.showPlanSectionHeaders) !== null && _c !== void 0 ? _c : QuoteSummaryWidget_1.quoteSummaryWidgetDefaultSettings.showPlanSectionHeaders,
                compactLineItemDescriptions: (_d = token.compactLineItemDescriptions) !== null && _d !== void 0 ? _d : QuoteSummaryWidget_1.quoteSummaryWidgetDefaultSettings.compactLineItemDescriptions,
                compactSectionHeaders: (_e = token.compactSectionHeaders) !== null && _e !== void 0 ? _e : QuoteSummaryWidget_1.quoteSummaryWidgetDefaultSettings.compactSectionHeaders,
            },
        });
    }, normalizeWidget: function (node, path, editor) { return (0, NormalizeVoidNode_1.normalizeVoidNode)(node, path, editor); }, validEditors: ["agreement"], validContainers: [], widgetAdderConfig: {
        tags: ["quote", "summary", "table", "total"],
        icon: react_1.default.createElement(icons_1.WidgetQuoteSummary, null),
        requiresFeatures: [FeatureFlag_1.FeatureFlag.AgreementViewWidget],
        displayName: "Quote summary",
    }, firstLastConfiguration: {
        isValidFirstChild: true,
    }, onAddWidget: function (_a) {
        var editor = _a.editor;
        (0, WidgetActions_1.addWidget)({
            editor: editor,
            widgetData: createQuoteSummaryNode(),
        });
    }, contentAddedType: TelemetryParameterValue_1.ContentAddedType.QuoteSummary, width: "full-width" }));
var buttonConfig = makeConfig(__assign(__assign({}, (0, CommonWidgetRegistry_1.getConfigByType)("button")), { editorRender: ButtonWidget_1.ButtonWidget, node: {}, toolbarButtons: ButtonWidget_1.ButtonWidgetMenu, serialise: function (node, editor, commentTracker, selection) { return __spreadArray([
        __assign({ subType: "button", type: "block" }, node.data)
    ], __read((0, Serialise_1.getChildTokens)(node, editor, commentTracker, selection)), false); }, deserialise: function (token, content, commentTracker) {
        var node = {
            type: "button",
            isVoid: true,
            data: {
                href: token.href,
                text: token.text,
            },
            children: [Text_1.text.createSlateJson()],
        };
        return node;
    }, nodeType: "void", normalizeWidget: function (node, path, editor) {
        if ((0, NormalizeVoidNode_1.normalizeVoidNode)(node, path, editor)) {
            return true;
        }
        else if (node.data.text == undefined) {
            var data = (0, lodash_1.cloneDeep)(node.data);
            data.text = "";
            slate_1.Transforms.setNodes(editor, { data: data }, { at: path });
            return true;
        }
        return false;
    }, firstLastConfiguration: {
        isValidFirstChild: true,
    }, validEditors: ["standard"], validContainers: ["accordionBody", "contentLoopBody", "sideBySideColumn", "boxColumn"], widgetAdderConfig: {
        tags: ["button"],
        icon: react_1.default.createElement(icons_1.WidgetButton, null),
        displayName: "Button",
    }, onAddWidget: function (_a) {
        var editor = _a.editor;
        (0, WidgetActions_1.addWidget)({
            editor: editor,
            widgetData: (0, exports.createButtonNode)(),
        });
    }, contentAddedType: TelemetryParameterValue_1.ContentAddedType.Button, width: "fit-widget" }));
var createButtonNode = function () { return ({
    type: "button",
    children: [Text_1.text.createSlateJson()],
    isVoid: true,
    data: {
        text: "",
    },
}); };
exports.createButtonNode = createButtonNode;
var createEmbedNode = function () { return ({
    children: [Text_1.text.createSlateJson()],
    data: {
        embedPreset: "iframe",
    },
    isVoid: true,
    type: "iframe",
}); };
var embedWidgetConfig = makeConfig(__assign(__assign({}, (0, CommonWidgetRegistry_1.getConfigByType)("iframe")), { editorRender: EmbedRegistryWidget_1.EmbedRegistryWidget, toolbarButtons: EmbedRegistryWidget_1.EmbedWidgetToolbarButtons, node: {}, nodeType: "void", serialise: function (node, editor, commentTracker, selection) {
        var token = __assign(__assign({ type: "block", subType: "iframe", embedPreset: node.data.embedPreset }, (0, CommonUtils_1.includeIf)(!!node.data.embedUrl, {
            embedUrl: node.data.embedUrl,
        })), (0, CommonUtils_1.includeIf)(!!node.data.variable, {
            variable: node.data.variable,
        }));
        return __spreadArray([token], __read((0, Serialise_1.getChildTokens)(node, editor, commentTracker, selection)), false);
    }, deserialise: function (token) {
        return {
            type: "iframe",
            children: [Text_1.text.createSlateJson()],
            isVoid: true,
            data: __assign(__assign({ embedPreset: token.embedPreset || "iframe" }, (0, CommonUtils_1.includeIf)(!!token.embedUrl, { embedUrl: token.embedUrl })), (0, CommonUtils_1.includeIf)(!!token.variable, {
                variable: token.variable,
            })),
        };
    }, normalizeWidget: function (node, path, editor) { return (0, NormalizeVoidNode_1.normalizeVoidNode)(node, path, editor); }, firstLastConfiguration: {
        isValidFirstChild: true,
    }, validEditors: ["standard"], validContainers: ["accordionBody", "contentLoopBody", "sideBySideColumn", "boxColumn"], widgetAdderConfig: {
        icon: react_1.default.createElement(icons_1.WidgetEmbed, null),
        displayName: "Embed",
        tags: ["iframe", "embed", "url"],
    }, onAddWidget: function (_a) {
        var editor = _a.editor;
        var node = createEmbedNode();
        (0, WidgetActions_1.addWidget)({
            editor: editor,
            widgetData: node,
        });
    }, contentAddedType: TelemetryParameterValue_1.ContentAddedType.Iframe, width: "full-width", widgetContextProvider: EmbedRegistryWidget_1.EmbedRegistryWidgetContextProvider }));
var createROICalculatorNode = function () {
    return {
        type: "roiCalculator",
        data: {
            slider: {
                label: "Main variable",
                increment: 1,
                min: 1,
                max: 100,
                initialValue: 20,
            },
            inputs: {
                A: {
                    label: "Example variable",
                    value: 80,
                    min: 0,
                    max: 1000,
                    prefix: "",
                    suffix: "",
                },
            },
            roiResult: {
                prefix: "$",
                suffix: "",
                formula: "{{slider}} * {{A}}",
                label: {
                    plain: "",
                },
            },
            title: {
                plain: "",
            },
            description: {
                plain: "",
            },
            variableCounter: 1,
            backgroundImageUrl: "",
            hasSelectedPreset: false,
        },
        children: [Text_1.text.createSlateJson()],
        isVoid: true,
    };
};
var WIDGET_ADDER_ENTRY_TOOLTIP_PREVIEW_IMAGE_DIMENSIONS = {
    height: 100,
    width: 168,
};
var roiCalculatorConfig = makeConfig(__assign(__assign({}, (0, CommonWidgetRegistry_1.getConfigByType)("roiCalculator")), { editorRender: ROICalculatorWidget_1.ROICalculatorRegistryWidget, toolbarButtons: ROICalculatorWidget_1.ROICalculatorToolbarButtons, node: {}, nodeType: "void", serialise: function (node, editor, commentTracker, selection) {
        var token = {
            type: "block",
            subType: "roiCalculator",
            slider: (0, lodash_1.cloneDeep)(node.data.slider),
            inputs: (0, lodash_1.cloneDeep)(node.data.inputs),
            roiResult: (0, lodash_1.cloneDeep)(node.data.roiResult),
            title: (0, lodash_1.cloneDeep)(node.data.title),
            description: (0, lodash_1.cloneDeep)(node.data.description),
            variableCounter: node.data.variableCounter,
            backgroundImageUrl: node.data.backgroundImageUrl,
            hasSelectedPreset: node.data.hasSelectedPreset,
        };
        return __spreadArray([token], __read((0, Serialise_1.getChildTokens)(node, editor, commentTracker, selection)), false);
    }, deserialise: function (token) {
        var _a;
        return {
            type: "roiCalculator",
            children: [Text_1.text.createSlateJson()],
            isVoid: true,
            data: {
                slider: token.slider,
                inputs: (_a = token.inputs) !== null && _a !== void 0 ? _a : {},
                roiResult: token.roiResult,
                title: token.title,
                description: token.description,
                variableCounter: token.variableCounter,
                backgroundImageUrl: token.backgroundImageUrl,
                hasSelectedPreset: token.hasSelectedPreset,
            },
        };
    }, normalizeWidget: function (node, path, editor) { return (0, NormalizeVoidNode_1.normalizeVoidNode)(node, path, editor); }, firstLastConfiguration: {
        isValidFirstChild: true,
    }, validEditors: ["standard"], validContainers: ["contentLoopBody"], widgetAdderConfig: {
        icon: react_1.default.createElement(icons_1.WidgetRoi, null),
        displayName: "ROI Calculator",
        tags: ["roi"],
        tooltip: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("img", __assign({ src: "Assets/Images/roi-tooltip-preview.gif" }, WIDGET_ADDER_ENTRY_TOOLTIP_PREVIEW_IMAGE_DIMENSIONS)),
            react_1.default.createElement("span", null, "Highlight ROI value with an interactive calculator"))),
    }, onAddWidget: function (_a) {
        var editor = _a.editor;
        var node = createROICalculatorNode();
        (0, WidgetActions_1.addWidget)({
            editor: editor,
            widgetData: node,
        });
    }, contentAddedType: TelemetryParameterValue_1.ContentAddedType.ROICalculator, width: "full-width" }));
var createGoogleMapsNode = function () { return ({
    children: [Text_1.text.createSlateJson()],
    isVoid: true,
    type: "googleMaps",
    data: {},
}); };
var googleMapsWidgetConfig = makeConfig(__assign(__assign({}, (0, CommonWidgetRegistry_1.getConfigByType)("googleMaps")), { editorRender: GoogleMapsRegistryWidget_1.GoogleMapsRegistryWidget, toolbarButtons: GoogleMapsToolbarButtons_1.GoogleMapsToolbarButtons, node: {}, nodeType: "void", serialise: function (node, editor, commentTracker, selection) {
        var token = __assign(__assign(__assign({ type: "block", subType: "googleMaps" }, (0, CommonUtils_1.includeIf)(!!node.data.displayUrl, {
            displayUrl: node.data.displayUrl,
        })), (0, CommonUtils_1.includeIf)(!!node.data.embedUrl, {
            embedUrl: node.data.embedUrl,
        })), (0, CommonUtils_1.includeIf)(!!node.data.variable, {
            variable: node.data.variable,
        }));
        return __spreadArray([token], __read((0, Serialise_1.getChildTokens)(node, editor, commentTracker, selection)), false);
    }, deserialise: function (token) {
        return {
            type: "googleMaps",
            children: [Text_1.text.createSlateJson()],
            isVoid: true,
            data: __assign(__assign(__assign({}, (0, CommonUtils_1.includeIf)(!!token.embedUrl, { embedUrl: token.embedUrl })), (0, CommonUtils_1.includeIf)(!!token.displayUrl, { displayUrl: token.displayUrl })), (0, CommonUtils_1.includeIf)(!!token.variable, {
                variable: token.variable,
            })),
        };
    }, normalizeWidget: function (node, path, editor) { return (0, NormalizeVoidNode_1.normalizeVoidNode)(node, path, editor); }, firstLastConfiguration: {
        isValidFirstChild: true,
    }, validEditors: ["standard"], validContainers: ["accordionBody", "contentLoopBody", "sideBySideColumn", "boxColumn"], widgetAdderConfig: {
        icon: react_1.default.createElement(icons_1.GoogleMaps, null),
        displayName: "Google Maps",
        tags: ["maps", "google maps"],
    }, onAddWidget: function (_a) {
        var editor = _a.editor;
        var node = createGoogleMapsNode();
        (0, WidgetActions_1.addWidget)({
            editor: editor,
            widgetData: node,
        });
    }, contentAddedType: TelemetryParameterValue_1.ContentAddedType.GoogleMaps, width: "full-width" }));
var imageWidgetConfig = makeConfig(__assign(__assign({}, (0, CommonWidgetRegistry_1.getConfigByType)("image")), { editorRender: ImageWidget_1.ImageWidgetRegistryWidget, toolbarButtons: ImageWidgetToolbarButtons_1.ImageWidgetToolbarButtons, widgetContextProvider: ImageWidgetContext_1.ImageWidgetContextProvider, node: {}, nodeType: "void", serialise: function (node, editor, commentTracker, selection) {
        if (!node.data.src && node.data.variable == null && node.data.uploadId) {
            return [];
        }
        var token = {
            type: "block",
            subType: "image",
            src: node.data.src,
        };
        if (node.data.href) {
            token.href = node.data.href;
        }
        if (node.data.alt) {
            token.alt = new Types_1.LiteralInput(node.data.alt);
        }
        if (node.data.role) {
            token.role = node.data.role;
        }
        if (node.data.frame) {
            token.frame = node.data.frame;
        }
        if (node.data.aspectRatio) {
            token.aspectRatio = node.data.aspectRatio;
        }
        if (node.data.scale) {
            token.scale = node.data.scale;
        }
        if (node.data.translation) {
            token.translation = node.data.translation;
        }
        if (node.data.variable) {
            token.variable = node.data.variable;
        }
        return __spreadArray([token], __read((0, Serialise_1.getChildTokens)(node, editor, commentTracker, selection)), false);
    }, deserialise: function (token) {
        var _a, _b;
        return {
            type: "image",
            children: [Text_1.text.createSlateJson()],
            isVoid: true,
            data: __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({ src: token.src || "" }, (0, CommonUtils_1.includeIf)(!!token.href, { href: token.href })), (0, CommonUtils_1.includeIf)(!!((_a = token.alt) === null || _a === void 0 ? void 0 : _a.value), { alt: (_b = token.alt) === null || _b === void 0 ? void 0 : _b.value })), (0, CommonUtils_1.includeIf)(!!token.role, { role: token.role })), (0, CommonUtils_1.includeIf)(!!token.frame, { frame: token.frame })), (0, CommonUtils_1.includeIf)(!!token.aspectRatio, { aspectRatio: token.aspectRatio })), (0, CommonUtils_1.includeIf)(!!token.uploadId, { uploadId: token.uploadId })), (0, CommonUtils_1.includeIf)(!!token.scale, { scale: token.scale })), (0, CommonUtils_1.includeIf)(!!token.translation, { translation: token.translation })), (0, CommonUtils_1.includeIf)(!!token.variable, {
                variable: token.variable,
            })),
        };
    }, normalizeWidget: function (node, path, editor) {
        if ((0, NormalizeVoidNode_1.normalizeVoidNode)(node, path, editor)) {
            return true;
        }
        if (node.data.src == undefined) {
            var updatedData = __assign(__assign({}, node.data), { src: "" });
            slate_1.Transforms.setNodes(editor, { data: updatedData }, { at: path });
            return true;
        }
        return false;
    }, firstLastConfiguration: {
        isValidFirstChild: true,
    }, validEditors: ["standard"], validContainers: ["accordionBody", "contentLoopBody", "sideBySideColumn", "boxColumn"], widgetAdderConfig: {
        icon: react_1.default.createElement(icons_1.WidgetImage, null),
        displayName: "Image",
        tags: ["picture", "icon", "img", "media"],
    }, onAddWidget: OnAddWidget_1.onAddImageWidget, contentAddedType: TelemetryParameterValue_1.ContentAddedType.Image, width: "full-width" }));
var accordionConfig = makeConfig(__assign(__assign({}, (0, CommonWidgetRegistry_1.getConfigByType)("accordion")), { node: {}, nodeType: "layoutElement", toolbarButtons: AccordionWidgetToolbarButtons_1.AccordionWidgetToolbarButtons, editorRender: AccordionRegistryWidget_1.AccordionRegistryWidget, firstLastConfiguration: { isValidFirstChild: true }, width: "full-width", deserialise: function (token, content, commentTracker) {
        var bodyContent;
        if (token.body && token.body.length === 0) {
            (0, DeserialiseErrorRecorder_1.sendEmptyAccordionBodyToSentry)({});
            bodyContent = { children: [(0, exports.createParagraphNode)()] };
        }
        else {
            bodyContent = (0, Deserialise_1.deserialiseNode)(token.body, commentTracker);
        }
        var headingContent = (0, Deserialise_1.deserialiseNode)(token.heading, commentTracker);
        var node = {
            type: "accordion",
            children: [
                { type: "accordionHeading", isVoid: false, children: headingContent.children },
                {
                    type: "accordionBody",
                    isVoid: false,
                    children: bodyContent.children,
                },
            ],
            isVoid: false,
            data: {
                expanded: false,
                backgroundImageUrl: token.backgroundImageUrl,
            },
        };
        var extractSelectionFromChild = function (index, areaContent) {
            if (areaContent.selection) {
                node.key = "tempAccordionKey";
                var accordionPath = (0, Deserialise_1.getPathToNodeBasedOnKey)(node.key, content.children.concat(node));
                if (areaContent.selection.anchor.path) {
                    areaContent.selection.anchor.path = accordionPath.concat([index], areaContent.selection.anchor.path);
                }
                if (areaContent.selection.focus.path) {
                    areaContent.selection.focus.path = accordionPath.concat([index], areaContent.selection.focus.path);
                }
                if (content.selection) {
                    if (content.selection.anchor.path) {
                        content.selection.focus = areaContent.selection.focus;
                    }
                    else {
                        content.selection.anchor = areaContent.selection.anchor;
                    }
                }
                else {
                    content.selection = areaContent.selection;
                }
                delete node.key;
            }
        };
        extractSelectionFromChild(0, headingContent);
        extractSelectionFromChild(1, bodyContent);
        return node;
    }, serialise: function (node, editor, commentTracker, selection) {
        var children = node.children;
        return [
            {
                type: "block",
                subType: "accordion",
                heading: (0, Serialise_1.serialiseElements)(children[0].children, editor, commentTracker, selection),
                body: (0, Serialise_1.serialiseElements)(children[1].children, editor, commentTracker, selection),
                backgroundImageUrl: node.data.backgroundImageUrl,
            },
        ];
    }, onAddWidget: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var blockStyleStore, stockImagesService, accordion, _c, selection, path, currBlockEntry;
        var editor = _b.editor, di = _b.di;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    blockStyleStore = di.get("blockStore").blockStyleStore;
                    stockImagesService = di.get("stockImageService");
                    accordion = createEmptyAccordion();
                    if (!isVisualAccordion(blockStyleStore)) return [3, 2];
                    _c = accordion.data;
                    return [4, stockImagesService.getRandomImage({ preventBoringImages: true })];
                case 1:
                    _c.backgroundImageUrl = (_d.sent()).url;
                    _d.label = 2;
                case 2:
                    selection = editor.selection;
                    path = selection.anchor.path;
                    currBlockEntry = (0, Utils_1.getClosestBlock)(editor, path);
                    if (!currBlockEntry) {
                        return [2];
                    }
                    slate_1.Editor.withoutNormalizing(editor, function () {
                        slate_1.Transforms.removeNodes(editor, { at: currBlockEntry[1] });
                        slate_1.Transforms.insertNodes(editor, accordion, { at: currBlockEntry[1] });
                    });
                    slate_1.Transforms.select(editor, path);
                    (0, lodash_1.defer)(function () {
                        slate_react_1.ReactEditor.focus(editor);
                    });
                    return [2];
            }
        });
    }); }, validContainers: ["contentLoopBody"], validEditors: ["standard"], normalizeWidget: function (node, path, editor) {
        if (!node.children.length) {
            slate_1.Transforms.removeNodes(editor, { at: path });
            return true;
        }
        if (!node.children[0] || node.children[0].type !== "accordionHeading") {
            slate_1.Transforms.insertNodes(editor, (0, exports.createAccordionHeading)(), { at: __spreadArray(__spreadArray([], __read(path), false), [0], false) });
            return true;
        }
        if (!node.children[1] || node.children[1].type !== "accordionBody") {
            slate_1.Transforms.insertNodes(editor, (0, exports.createAccordionBody)(), { at: __spreadArray(__spreadArray([], __read(path), false), [1], false) });
            return true;
        }
        if (node.children.length > 2) {
            slate_1.Transforms.removeNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [2], false) });
            return true;
        }
        return false;
    }, widgetAdderConfig: {
        icon: react_1.default.createElement(icons_1.AccordionLeftButton, null),
        tags: ["accordion", "foldable", "toggle"],
        displayName: "Accordion",
        requiresFeatures: [FeatureFlag_1.FeatureFlag.Accordion],
        tooltip: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("img", __assign({ src: "Assets/Images/accordion-tooltip-preview.gif" }, WIDGET_ADDER_ENTRY_TOOLTIP_PREVIEW_IMAGE_DIMENSIONS)),
            react_1.default.createElement("span", null, "Add foldable content within your blocks"))),
    }, contentAddedType: TelemetryParameterValue_1.ContentAddedType.Accordion, containerNodeConfiguration: {
        showWidgetAdder: false,
    }, widgetContextProvider: AccordionRegistryContext_1.AccordionRegistryContextProvider }));
var isVisualAccordion = function (blockStyleStore) {
    var accordionStyles = blockStyleStore.getElementStyle("accordion");
    return accordionStyles.cardStyle === BlockStyleTypes_1.AccordionWidgetCardStyle.Visual;
};
var createAccordionHeading = function () {
    return {
        isVoid: false,
        type: "accordionHeading",
        children: [(0, exports.createHeading2Node)()],
    };
};
exports.createAccordionHeading = createAccordionHeading;
var createAccordionBody = function () {
    return {
        isVoid: false,
        type: "accordionBody",
        children: [(0, exports.createParagraphNode)()],
    };
};
exports.createAccordionBody = createAccordionBody;
var sideBySideConfig = makeConfig(__assign(__assign({}, (0, CommonWidgetRegistry_1.getConfigByType)("sideBySide")), { node: {}, nodeType: "layoutElement", editorRender: SideBySideWidget_1.default, firstLastConfiguration: { isValidFirstChild: true }, width: "full-width", deserialise: function (token, content, commentTracker) {
        var e_1, _a;
        var _b;
        var nodeHasKey = function (node) {
            return !!node.key;
        };
        var getPath = function (key, value) {
            for (var i = 0; i < value.length; i++) {
                var node = value[i];
                if (nodeHasKey(node) && node.key == key) {
                    return [i];
                }
                if ("children" in node && node.children.length > 0) {
                    var maybePath = getPath(key, node.children);
                    if (maybePath) {
                        return [i].concat(maybePath);
                    }
                }
            }
            return null;
        };
        var getPlaceholderIndex = function (order, renderPlaceholder, placeholderIndex) {
            if (!order) {
                return placeholderIndex;
            }
            if (!renderPlaceholder) {
                return null;
            }
            return order === SideBySide_1.SideBySideOrder.Normal ? SideBySide_1.SideBySidePlaceholderIndex.Column2 : SideBySide_1.SideBySidePlaceholderIndex.Column1;
        };
        var placeholderIndex = getPlaceholderIndex(token.order, token.renderPlaceholder, token.placeholderIndex);
        var sideBySideNode = {
            type: "sideBySide",
            isVoid: false,
            data: {
                percent: token.percent,
                placeholderIndex: placeholderIndex,
            },
            children: [],
        };
        var columnNum = -1;
        var columns = ((_b = token.order) !== null && _b !== void 0 ? _b : SideBySide_1.SideBySideOrder.Normal) === SideBySide_1.SideBySideOrder.Normal
            ? [token.column1, token.column2]
            : [token.column2, token.column1];
        try {
            for (var columns_1 = __values(columns), columns_1_1 = columns_1.next(); !columns_1_1.done; columns_1_1 = columns_1.next()) {
                var column = columns_1_1.value;
                columnNum++;
                var columnContent = void 0;
                if (column && column.length === 0) {
                    columnContent = { children: [(0, exports.createParagraphNode)()] };
                }
                else {
                    columnContent = (0, Deserialise_1.deserialiseNode)(column, commentTracker);
                }
                var columnNode = {
                    type: "sideBySideColumn",
                    isVoid: false,
                    children: columnContent.children,
                };
                sideBySideNode.children.push(columnNode);
                if (columnContent.selection) {
                    sideBySideNode.key = "tempSideBySideKey";
                    var sideBySidePath = getPath(sideBySideNode.key, content.children.concat(sideBySideNode));
                    if (columnContent.selection.anchor.path) {
                        columnContent.selection.anchor.path = sideBySidePath.concat([columnNum], columnContent.selection.anchor.path);
                    }
                    if (columnContent.selection.focus.path) {
                        columnContent.selection.focus.path = sideBySidePath.concat([columnNum], columnContent.selection.focus.path);
                    }
                    if (content.selection) {
                        if (content.selection.anchor.path) {
                            content.selection.focus = columnContent.selection.focus;
                        }
                        else {
                            content.selection.anchor = columnContent.selection.anchor;
                        }
                    }
                    else {
                        content.selection = columnContent.selection;
                    }
                    delete sideBySideNode.key;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (columns_1_1 && !columns_1_1.done && (_a = columns_1.return)) _a.call(columns_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return sideBySideNode;
    }, serialise: function (block, editor, commentTracker, selection) {
        var newToken = {
            type: "block",
            subType: "sideBySide",
            percent: block.data.percent || 50,
            placeholderIndex: block.data.placeholderIndex || null,
            column1: null,
            column2: null,
        };
        var children = block.children;
        newToken.column1 = (0, Serialise_1.mergeText)((0, Serialise_1.serialiseElements)(children[0].children, editor, commentTracker, selection));
        newToken.column2 = (0, Serialise_1.mergeText)((0, Serialise_1.serialiseElements)(children[1].children, editor, commentTracker, selection));
        var sideBySideTokens = [newToken];
        return sideBySideTokens;
    }, onAddWidget: function (_a) {
        var editor = _a.editor;
        var widget = createSideBySideNode();
        var currentSelection = editor.selection;
        if (!slate_1.Range.isRange(currentSelection)) {
            return;
        }
        var currBlockEntry = (0, Utils_1.getClosestBlock)(editor, slate_1.Range.start(currentSelection).path);
        if (!currBlockEntry) {
            return;
        }
        slate_1.Editor.withoutNormalizing(editor, function () {
            slate_1.Transforms.removeNodes(editor, { at: currBlockEntry[1] });
            slate_1.Transforms.insertNodes(editor, widget, { at: currBlockEntry[1] });
        });
    }, validContainers: ["contentLoopBody"], validEditors: ["standard"], normalizeWidget: function (node, path, editor) {
        var SIDE_BY_SIDE_NUM_CHILDREN = 2;
        var replaceChildWithSideBySideColAtIndex = function (editor, path, index) {
            slate_1.Editor.withoutNormalizing(editor, function () {
                slate_1.Transforms.removeNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [index], false) });
                slate_1.Transforms.insertNodes(editor, (0, exports.createSideBySideColumnNode)(), { at: __spreadArray(__spreadArray([], __read(path), false), [index], false) });
            });
        };
        if (node.children.length === SIDE_BY_SIDE_NUM_CHILDREN) {
            if (node.children[0].type !== "sideBySideColumn") {
                replaceChildWithSideBySideColAtIndex(editor, path, 1);
                return true;
            }
            if (node.children[1].type !== "sideBySideColumn") {
                replaceChildWithSideBySideColAtIndex(editor, path, 2);
                return true;
            }
        }
        if (node.children.length < SIDE_BY_SIDE_NUM_CHILDREN) {
            slate_1.Transforms.insertNodes(editor, (0, exports.createSideBySideColumnNode)(), { at: __spreadArray(__spreadArray([], __read(path), false), [1], false) });
            return true;
        }
        if (node.children.length > SIDE_BY_SIDE_NUM_CHILDREN) {
            slate_1.Transforms.removeNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [2], false) });
            return true;
        }
        return false;
    }, widgetAdderConfig: {
        icon: react_1.default.createElement(icons_1.WidgetTwoColumns, null),
        tags: ["2 columns", "two columns", "columns", "sidebyside", "side by side", "2columns", "twocolumns"],
        displayName: "2 Columns",
    }, contentAddedType: TelemetryParameterValue_1.ContentAddedType.SideBySide, containerNodeConfiguration: {
        showWidgetAdder: false,
    } }));
var contentLoopConfig = makeConfig(__assign(__assign({}, (0, CommonWidgetRegistry_1.getConfigByType)("contentLoop")), { node: {}, nodeType: "layoutElement", editorRender: ContentLoopRegistryWidget_1.ContentLoopRegistryWidget, onAddWidget: function (_a) {
        var editor = _a.editor;
        if (!editor.selection) {
            return;
        }
        var nodeEntry = (0, Utils_1.getClosestBlock)(editor, editor.selection.anchor.path);
        if (!nodeEntry) {
            return;
        }
        var _b = __read(nodeEntry, 2), path = _b[1];
        var contentLoopNode = (0, exports.createContentLoopNode)();
        (0, Utils_1.replaceNodes)(editor, contentLoopNode, { at: path });
    }, normalizeWidget: function (node, path, editor, schema) {
        if (!node.children.length || node.children[0].type !== "contentLoopBody") {
            slate_1.Transforms.insertNodes(editor, (0, exports.createContentLoopBodyNode)(), { at: __spreadArray(__spreadArray([], __read(path), false), [0], false) });
            return true;
        }
        if (node.children.length > 1) {
            slate_1.Transforms.removeNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [1], false) });
            return true;
        }
        return false;
    }, serialise: function (node, editor, commentTracker, selection) {
        var token = __assign({ type: "block", subType: "contentLoop", content: (0, Serialise_1.serialiseElements)(node.children[0].children, editor, commentTracker, selection) }, (0, CommonUtils_1.includeIf)(!!node.data.variable, { variable: node.data.variable }));
        return [token];
    }, deserialise: function (token, content, commentTracker) {
        return {
            type: "contentLoop",
            isVoid: false,
            data: __assign({}, (0, CommonUtils_1.includeIf)(!!token.variable, { variable: __assign(__assign({}, token.variable), { dataSource: Types_1.DataSource.Token }) })),
            children: [
                { children: (0, Deserialise_1.deserialiseNode)(token.content, commentTracker).children, isVoid: false, type: "contentLoopBody" },
            ],
        };
    }, firstLastConfiguration: {
        isValidFirstChild: true,
    }, validContainers: [], validEditors: ["standard"], width: "full-width", containerNodeConfiguration: {
        showWidgetAdder: false,
        validChildren: [],
    }, widgetAdderConfig: {
        icon: react_1.default.createElement(icons_1.Loop, null),
        requiresFeatures: [FeatureFlag_1.FeatureFlag.PublicApi],
        displayName: "Repeating content",
        tags: ["content loop", "loop", "looping", "for", "foreach", "variable", "repeat", "repeating"],
    }, requiresTokenAvailability: true, toolbarButtons: ContentLoopToolbarButtons_1.ContentLoopToolbarButtons, widgetContextProvider: ContentLoopWidgetContext_1.ContentLoopWidgetContextProvider }));
exports.configs = [
    chevronConfig,
    boxConfig,
    horizontalRuleConfig,
    heading1Config,
    heading2Config,
    paragraphConfig,
    listItemConfig,
    blockQuoteConfig,
    quoteSummaryConfig,
    videoWidgetConfig,
    buttonConfig,
    embedWidgetConfig,
    roiCalculatorConfig,
    googleMapsWidgetConfig,
    imageWidgetConfig,
    accordionConfig,
    sideBySideConfig,
    contentLoopConfig,
];
var contentLoopBodyConfig = makeContainerManagedConfig({
    node: {},
    nodeType: "layoutElement",
    type: "contentLoopBody",
    editorRender: ContentLoopBodyRegistry_1.ContentLoopBody,
    validContainers: ["contentLoop"],
    width: "full-width",
    normalizeWidget: function (node, path, editor, schema) {
        var _a, _b, _c;
        for (var i = 0; i < node.children.length; i++) {
            var currChild = node.children[i];
            if (typeof currChild === "undefined" || slate_1.Text.isText(currChild)) {
                slate_1.Transforms.delete(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false) });
                return true;
            }
            if (!((_b = (_a = (0, exports.getConfigByType)("contentLoopBody").containerNodeConfiguration) === null || _a === void 0 ? void 0 : _a.validChildren) === null || _b === void 0 ? void 0 : _b.includes(currChild.type)) &&
                !((_c = getGenericConfigByType(currChild.type, true)) === null || _c === void 0 ? void 0 : _c.validContainers.includes(node.type))) {
                slate_1.Transforms.unwrapNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false), voids: true });
                return true;
            }
        }
        if (node.children.length === 0) {
            slate_1.Transforms.insertNodes(editor, (0, exports.createParagraphNode)(), {
                at: __spreadArray(__spreadArray([], __read(path), false), [0], false),
            });
            return true;
        }
        return false;
    },
    containerNodeConfiguration: {
        validChildren: [],
        showWidgetAdder: true,
        supportWideWidgets: true,
    },
});
var containerManagedConfigs = [
    makeContainerManagedConfig({
        node: {},
        nodeType: "layoutElement",
        type: "boxColumn",
        editorRender: BoxColumn_1.BoxColumn,
        validContainers: ["box"],
        width: "full-width",
        normalizeWidget: function (node, path, editor) {
            var _a, _b, _c;
            for (var i = 0; i < node.children.length; i++) {
                var currChild = node.children[i];
                if (slate_1.Text.isText(currChild)) {
                    slate_1.Transforms.delete(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false) });
                    return true;
                }
                if (!((_b = (_a = (0, exports.getConfigByType)("boxColumn").containerNodeConfiguration) === null || _a === void 0 ? void 0 : _a.validChildren) === null || _b === void 0 ? void 0 : _b.includes(currChild.type)) &&
                    !((_c = getGenericConfigByType(currChild.type, true)) === null || _c === void 0 ? void 0 : _c.validContainers.includes(node.type))) {
                    slate_1.Transforms.delete(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false) });
                    return true;
                }
            }
            if (node.children.length === 0) {
                slate_1.Transforms.insertNodes(editor, (0, exports.createParagraphNode)(), {
                    at: __spreadArray(__spreadArray([], __read(path), false), [0], false),
                });
                return true;
            }
            return false;
        },
        containerNodeConfiguration: {
            validChildren: [],
            showWidgetAdder: true,
        },
    }),
    makeContainerManagedConfig({
        node: {},
        nodeType: "layoutElement",
        type: "accordionHeading",
        editorRender: AccordionHeading_1.AccordionHeadingRegistryWidget,
        validContainers: ["accordion"],
        width: "full-width",
        normalizeWidget: function (node, path, editor) {
            var _a, _b, _c;
            if (node.children && node.children.length > 1) {
                var _d = __read((0, Utils_1.getNext)(editor, path, function (curr) {
                    return slate_2.Element.isElement(curr) && curr.type === "accordionBody";
                }), 2), accordionBody = _d[0], accordionBodyPath = _d[1];
                if (slate_2.Element.isElement(node.children[1]) && slate_1.Editor.isEmpty(editor, node.children[1])) {
                    slate_1.Transforms.removeNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [1], false) });
                    (0, Utils_1.moveToStartOfNextText)(editor);
                }
                else {
                    slate_1.Transforms.moveNodes(editor, {
                        at: __spreadArray(__spreadArray([], __read(path), false), [node.children.length - 1], false),
                        to: __spreadArray(__spreadArray([], __read(accordionBodyPath), false), [0], false),
                    });
                }
                return true;
            }
            for (var i = 0; i < node.children.length; i++) {
                var currChild = node.children[i];
                if (slate_1.Text.isText(currChild)) {
                    slate_1.Transforms.delete(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false) });
                    return true;
                }
                if (!((_b = (_a = (0, exports.getConfigByType)("accordionHeading").containerNodeConfiguration) === null || _a === void 0 ? void 0 : _a.validChildren) === null || _b === void 0 ? void 0 : _b.includes(currChild.type)) &&
                    !((_c = getGenericConfigByType(currChild.type, true)) === null || _c === void 0 ? void 0 : _c.validContainers.includes(node.type))) {
                    slate_1.Transforms.unwrapNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false), voids: true });
                    return true;
                }
            }
            if (node.children.length === 0) {
                slate_1.Transforms.insertNodes(editor, (0, exports.createParagraphNode)(), {
                    at: __spreadArray(__spreadArray([], __read(path), false), [0], false),
                });
                return true;
            }
            return false;
        },
        containerNodeConfiguration: {
            validChildren: [],
            showWidgetAdder: false,
        },
    }),
    makeContainerManagedConfig({
        node: {},
        nodeType: "layoutElement",
        type: "accordionBody",
        editorRender: AccordionBody_1.AccordionBodyRegistryWidget,
        validContainers: ["accordion"],
        width: "full-width",
        normalizeWidget: function (node, path, editor) {
            var _a, _b, _c;
            for (var i = 0; i < node.children.length; i++) {
                var currChild = node.children[i];
                if (slate_1.Text.isText(currChild)) {
                    slate_1.Transforms.delete(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false) });
                    return true;
                }
                if (!((_b = (_a = (0, exports.getConfigByType)("accordionBody").containerNodeConfiguration) === null || _a === void 0 ? void 0 : _a.validChildren) === null || _b === void 0 ? void 0 : _b.includes(currChild.type)) &&
                    !((_c = getGenericConfigByType(currChild.type, true)) === null || _c === void 0 ? void 0 : _c.validContainers.includes(node.type))) {
                    slate_1.Transforms.unwrapNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false), voids: true });
                    return true;
                }
            }
            if (node.children.length === 0) {
                slate_1.Transforms.insertNodes(editor, (0, exports.createParagraphNode)(), {
                    at: __spreadArray(__spreadArray([], __read(path), false), [0], false),
                });
                return true;
            }
            return false;
        },
        containerNodeConfiguration: {
            validChildren: [],
            showWidgetAdder: true,
        },
    }),
    makeContainerManagedConfig({
        node: {},
        nodeType: "layoutElement",
        type: "sideBySideColumn",
        editorRender: SideBySideColumn_1.SideBySideColumn,
        validContainers: ["sideBySide"],
        width: "full-width",
        normalizeWidget: function (node, path, editor) {
            var _a, _b, _c;
            for (var i = 0; i < node.children.length; i++) {
                var currChild = node.children[i];
                if (slate_1.Text.isText(currChild)) {
                    slate_1.Transforms.delete(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false) });
                    return true;
                }
                if (!((_b = (_a = (0, exports.getConfigByType)("sideBySideColumn").containerNodeConfiguration) === null || _a === void 0 ? void 0 : _a.validChildren) === null || _b === void 0 ? void 0 : _b.includes(currChild.type)) &&
                    !((_c = getGenericConfigByType(currChild.type, true)) === null || _c === void 0 ? void 0 : _c.validContainers.includes(node.type))) {
                    slate_1.Transforms.unwrapNodes(editor, { at: __spreadArray(__spreadArray([], __read(path), false), [i], false), voids: true });
                    return true;
                }
            }
            if (node.children.length === 0) {
                slate_1.Transforms.insertNodes(editor, (0, exports.createParagraphNode)(), {
                    at: __spreadArray(__spreadArray([], __read(path), false), [0], false),
                });
                return true;
            }
            return false;
        },
        containerNodeConfiguration: {
            validChildren: [],
            showWidgetAdder: true,
        },
    }),
    contentLoopBodyConfig,
];
var createEmptyBoxColumn = function () { return ({
    type: "boxColumn",
    children: [(0, exports.createParagraphNode)()],
    isVoid: false,
}); };
var createEmptyBox = function () { return ({
    children: [createEmptyBoxColumn(), createEmptyBoxColumn()],
    isVoid: false,
    type: "box",
    data: {},
}); };
var createEmptyAccordion = function () { return ({
    isVoid: false,
    type: "accordion",
    data: { expanded: false },
    children: [(0, exports.createAccordionHeading)(), (0, exports.createAccordionBody)()],
}); };
var createSideBySideColumnNode = function () { return ({
    type: "sideBySideColumn",
    children: [(0, exports.createParagraphNode)()],
    isVoid: false,
}); };
exports.createSideBySideColumnNode = createSideBySideColumnNode;
var createSideBySideNode = function () { return ({
    type: "sideBySide",
    children: [(0, exports.createSideBySideColumnNode)(), (0, exports.createSideBySideColumnNode)()],
    isVoid: false,
    data: {
        percent: SideBySide_1.SideBySideColumnSize.OneHalf,
        placeholderIndex: SideBySide_1.SideBySidePlaceholderIndex.Column2,
    },
}); };
var createContentLoopBodyNode = function () {
    return { children: [(0, exports.createParagraphNode)()], type: "contentLoopBody", isVoid: false };
};
exports.createContentLoopBodyNode = createContentLoopBodyNode;
var createContentLoopNode = function () { return ({
    type: "contentLoop",
    children: [(0, exports.createContentLoopBodyNode)()],
    data: {},
    isVoid: false,
}); };
exports.createContentLoopNode = createContentLoopNode;
var getConfigByType = function (type) {
    var e_2, _a, e_3, _b;
    try {
        for (var configs_1 = __values(exports.configs), configs_1_1 = configs_1.next(); !configs_1_1.done; configs_1_1 = configs_1.next()) {
            var config = configs_1_1.value;
            if (config.type === type) {
                return config;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (configs_1_1 && !configs_1_1.done && (_a = configs_1.return)) _a.call(configs_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    try {
        for (var containerManagedConfigs_1 = __values(containerManagedConfigs), containerManagedConfigs_1_1 = containerManagedConfigs_1.next(); !containerManagedConfigs_1_1.done; containerManagedConfigs_1_1 = containerManagedConfigs_1.next()) {
            var config = containerManagedConfigs_1_1.value;
            if (config.type === type) {
                return config;
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (containerManagedConfigs_1_1 && !containerManagedConfigs_1_1.done && (_b = containerManagedConfigs_1.return)) _b.call(containerManagedConfigs_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
    throw new Error("Config with type ".concat(type, " not registered"));
};
exports.getConfigByType = getConfigByType;
function getGenericConfigByType(type, includeContainerManagedWidgets) {
    if ((0, exports.isContainerManagedWidget)(type) && !includeContainerManagedWidgets) {
        return undefined;
    }
    try {
        return (0, exports.getConfigByType)(type);
    }
    catch (_a) {
        return undefined;
    }
}
exports.getGenericConfigByType = getGenericConfigByType;
var isContainerManagedWidget = function (type) {
    return !!containerManagedConfigs.find(function (f) { return f.type === type; });
};
exports.isContainerManagedWidget = isContainerManagedWidget;
var isResizeableWidget = function (widget) {
    try {
        return !!(0, CommonWidgetRegistry_1.getTraitConfig)({ widgetType: widget.type, traitName: "resizeable" });
    }
    catch (_a) {
        return false;
    }
};
exports.isResizeableWidget = isResizeableWidget;
var isAlignableWidget = function (widget) {
    try {
        return !!(0, CommonWidgetRegistry_1.getTraitConfig)({ widgetType: widget.type, traitName: "alignable" });
    }
    catch (_a) {
        return false;
    }
};
exports.isAlignableWidget = isAlignableWidget;
